import { createTransform } from 'redux-persist';
// eslint-disable-next-line import/no-extraneous-dependencies
import CryptoJS from 'crypto-js';

// Function to obfuscate keys
export const obfuscateKey = (key: string): string => {
    return CryptoJS.SHA256(key).toString(CryptoJS.enc.Base64);
  };
  
  // Function to restore keys (if needed in debugging)
  export const restoreKey = (obfuscatedKey: string): string => {
    // In this implementation, restoring keys is not required
    // If needed, you can maintain a mapping of keys and obfuscated values.
    return obfuscatedKey;
  };

// Custom transform to encrypt and decrypt values
const encryptDecryptTransform = createTransform(
  // Transform state before saving to storage (encryption)
  (inboundState: any) => {
    try {
      const encrypted = CryptoJS.AES.encrypt(
        JSON.stringify(inboundState),
        '837145789347957984378965983475' // Replace with a secure key
      ).toString();
      return encrypted;
    } catch (error) {
      console.error('Encryption error:', error);
      return inboundState; // Return original state on error
    }
  },
  // Transform state after rehydration (decryption)
  (outboundState: any) => {
    try {
        const decrypted = CryptoJS.AES.decrypt(
          outboundState,
          '837145789347957984378965983475' // Replace with the same key used for encryption
        ).toString(CryptoJS.enc.Utf8);
        return JSON.parse(decrypted);
      } catch (error) {
      console.error('Decryption error:', error);
      return outboundState; // Return original state on error
    }
  }
);

export default encryptDecryptTransform;
